import type { LucideIcon } from "lucide-react";
import { Factory, Import, ListChecks, Truck } from "lucide-react";
import { FlowEntryCard } from "@/components/navigate-to-mass-update-flow/FlowEntryCard";
import type { MassUpdateFlow, MassUpdateFlowId } from "@/mocks/navigate-to-mass-update-flow";

const FLOW_ICONS: Record<MassUpdateFlowId, LucideIcon> = {
  "sales-orders": Truck,
  "work-orders": Factory,
  "import-work-orders": Import,
  jobs: ListChecks,
};

interface FlowEntryGridProps {
  flows: MassUpdateFlow[];
}

export function FlowEntryGrid({ flows }: FlowEntryGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {flows.map((flow) => (
        <FlowEntryCard key={flow.id} flow={flow} icon={FLOW_ICONS[flow.id]} />
      ))}
    </div>
  );
}
